module.exports = __webpack_public_path__ + "static/media/logBattery.2664c9d1.svg";